<form
	#editForm="ngForm"
	[formReset]="editForm"
	(ngSubmit)="editForm.valid && submit()">
	<div class="modal-header">
		<h4
			class="modal-title"
			*ngIf="!loading">
			{{'labels.' + title | translate}}
		</h4>
		<button
			type="button"
			class="close"
			aria-label="Close"
			(click)="dismiss()">
			<span aria-hidden="true">×</span>
		</button>
	</div>
	<div
		class="modal-body"
		ngbAutofocus>
		<div
			class="row"
			*ngIf="loading">
			<div class="col text-center">
				<app-loader [material]="false"></app-loader>
			</div>
		</div>

		<div
			class="row"
			*ngIf="!loading && kpi">
			<div class="col-sm-12">
				<div class="row">
					<!-- activity -->
					<div class="form-group col-md-4">
						<label for="activityinput">{{ 'labels.activity' | translate }}*</label>
						<input
							name="activityinput"
							[placeholder]="activity?.name"
							required
							type="text"
							class="form-control"
							id="activityinput"
							disabled>

					</div>
					<!-- kpiname -->
					<div class="form-group col-md-4">
						<label>{{'activitykpi.kpiname' | translate}}*</label>
						<input
							type="text"
							class="form-control"
							name="kpiname"
							[(ngModel)]="kpi.kpiname"
							required
							#kpiname="ngModel"
							[ngClass]="{'is-invalid': editForm.submitted && kpiname.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && kpiname.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- unit -->
					<div class="form-group col-md-4">
						<label>{{'activitykpi.unit' | translate}}*</label>
						<select
							class="form-control custom-select"
							[(ngModel)]="kpi.unit"
							required
							#unit="ngModel"
							name="unit"
							[ngClass]="{'is-invalid': editForm.submitted && unit.invalid}">
							<option
								*ngFor="let u of units"
								[value]="u.itemvalue">
								{{u.itemlabel}}
							</option>
						</select>
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && unit.invalid"
							style="display: block;">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- intmin -->
					<div class="form-group col-md-3">
						<label>{{'activitykpi.intmin' | translate}}*</label>
						<input
							type="number"
							class="form-control"
							name="intmin"
							[(ngModel)]="kpi.intmin"
							required
							#intmin="ngModel"
							[ngClass]="{'is-invalid': editForm.submitted && intmin.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && intmin.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- intmax -->
					<div class="form-group col-md-3">
						<label>{{'activitykpi.intmax' | translate}}*</label>
						<input
							type="number"
							class="form-control"
							name="intmax"
							[(ngModel)]="kpi.intmax"
							required
							#intmax="ngModel"
							[ngClass]="{'is-invalid': editForm.submitted && intmax.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && intmax.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- finalmin -->
					<div class="form-group col-md-3">
						<label>{{'activitykpi.finalmin' | translate}}*</label>
						<input
							type="number"
							class="form-control"
							name="finalmin"
							[(ngModel)]="kpi.finalmin"
							required
							#finalmin="ngModel"
							[ngClass]="{'is-invalid': editForm.submitted && finalmin.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && finalmin.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- finalmax -->
					<div class="form-group col-md-3">
						<label>{{'activitykpi.finalmax' | translate}}*</label>
						<input
							type="number"
							class="form-control"
							name="finalmax"
							[(ngModel)]="kpi.finalmax"
							required
							#finalmax="ngModel"
							[ngClass]="{'is-invalid': editForm.submitted && finalmax.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && finalmax.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- intkpidate -->
					<div class="form-group col-md-3">
						<label>
							{{'activitykpi.intkpidate' | translate}}*
						</label>
						<app-datepicker
							[(ngModel)]="kpi.intkpidate"
							name="intkpidate"
							required
							#intkpidate="ngModel"
							[ngClass]="{'is-invalid': editForm.submitted && intkpidate.invalid}">
						</app-datepicker>
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && intkpidate.invalid"
							style="display: block;">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- finalkpidate -->
					<div class="form-group col-md-3">
						<label>
							{{'activitykpi.finalkpidate' | translate}}*
						</label>
						<app-datepicker
							[(ngModel)]="kpi.finalkpidate"
							name="finalkpidate"
							required
							#finalkpidate="ngModel"
							[ngClass]="{'is-invalid': editForm.submitted && finalkpidate.invalid}">
						</app-datepicker>
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && finalkpidate.invalid"
							style="display: block;">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- description -->
					<div class="form-group col-md-6">
						<label>
							{{ 'activitykpi.description' | translate }}
						</label>
						<textarea
							[(ngModel)]="kpi.description"
							#description="ngModel"
							name="description"
							type="text"
							class="form-control"
							placeholder="{{ 'activitykpi.description' | translate }}"
							required
							[ngClass]="{'is-invalid': editForm.submitted && description.invalid}">
						</textarea>
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && description.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
				</div>
			</div>

		</div>
	</div>
	<div class="modal-footer">

		<button
			type="reset"
			class="btn btn-secondary">
			{{'labels.reset' | translate}}
		</button>
		<button
			type="button"
			class="btn btn-secondary"
			(click)="dismiss()">
			{{'labels.cancel' | translate}}
		</button>
		<button
			type="submit"
			class="btn btn-primary">
			{{'labels.save' | translate}}
		</button>
	</div>
</form>
